module.exports = __webpack_public_path__ + "static/media/allcall_marker_hover.3ce164fd.svg";